import React, {useState} from 'react';
import Select from "react-select";

const SelectInput = ({ onChange }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const options = [
        "Vi una Minca en la calle",
        "Un amigo",
        "Una valla publicitaria",
        "Google",
        "Facebook",
        "Instagram",
        "TikTok"
      ].map(option => ({
        value: option,
        label: option,
    }));

    const customStyle = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: 'all .2s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
        }),
        menu: (base, state) => ({
            height: "230px",
            backgroundColor: "white",
            zIndex: 1000, // Add zIndex to ensure the dropdown appears on top
            position: 'absolute', // This helps to avoid affecting the layout below
            width: "100%",
            paddingLeft: "16px",
            paddingRight: "16px",
            overflow: "auto",
            borderRadius: "10px"
        }),
        option: (base, state) => ({
            backgroundColor: "white",
            paddingTop: "15px",
            /* "&:hover": {
                backgroundColor: "blue",
            } */
        }),
        control: (base, state) => ({
            ...base,
            height: "60px",
            borderColor: "none",
            borderRadius: "10px",
            boxShadow: "none",
            "&:hover": {
                borderColor: "none"
            }
        })
        // Add more styles as needed
    };

    return (
        <div className="w-full">
            <Select
                inputId="whereYouKnow"
                name="whereYouKnow"
                defaultValue={selectedOption}
                onChange={option => {
                    setSelectedOption(option);
                    onChange(option.value); // Call the onChange handler with the selected value
                }}
                options={options}
                styles={customStyle}
                placeholder="Por favor seleccione"
                required
            />
        </div>
    );
};

export default SelectInput;
